/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Orgmanagerv1Org } from '../models/Orgmanagerv1Org';
import { HttpFile } from '../http/http';

export class V1BatchUpdateOrgsResponse {
    'orgs'?: Array<Orgmanagerv1Org>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "orgs",
            "baseName": "orgs",
            "type": "Array<Orgmanagerv1Org>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1BatchUpdateOrgsResponse.attributeTypeMap;
    }

    public constructor() {
    }
}

